import TagManager from 'react-gtm-module';

const PushDataLayerMCP = (pageType, pageCategory, brandName, category, vehicleClass) => {
  const dataLayer = {};

  dataLayer.MCP = {
    PageType: pageType,
    PageCategory: pageCategory,
    Brand: brandName,
    Category: category,
    Class: vehicleClass,
  };

  if (typeof window !== 'undefined' && !!window) {
    TagManager.dataLayer({
      dataLayer: dataLayer,
    });
  }
};

export default PushDataLayerMCP;
